<script setup lang="ts">
import { useColorMode } from '@vueuse/core'
import NavbarTopBar from 'pejer/src/components/Navbar/NavbarTopBar.vue'
import { Toaster } from 'pejer/src/components/ui/toast'
import { onMounted } from 'vue'
import Navbar from './components/Navbar/Navbar.vue'

const mode = useColorMode({ initialValue: 'light' })

onMounted(() => {
  mode.value = 'light'
})
</script>
<template>
  <div class="flex text-slate-700">
    <Navbar
      class="mt-[--topbar-height] h-[calc(100vh-var(--topbar-height))] shadow-lg"
      v-if="!$route.meta?.hideNavbar"
    />
    <NavbarTopBar
      v-if="!$route.meta?.hideNavbar"
      class="w-[--sidebar-closed-width] xl:w-[--sidebar-width]"
    />
    <main
      class="flex min-h-[100vh] items-center justify-center w-full"
      :class="{
        'ml-[--sidebar-closed-width] w-[calc(100vw-var(--sidebar-closed-width))] xl:ml-[--sidebar-width] xl:w-[calc(100vw-var(--sidebar-width))]':
          !$route.meta?.hideNavbar,
        ' w-full': $route.meta?.hideNavbar,
        'bg-slate-100 p-3': !$route.meta?.fillScreen,
      }"
    >
      <RouterView
        v-slot="{ Component }"
        class="bg-slate-100 rounded-sm max-w-[1500px]"
        :class="{
          'w-full min-h-full': !$route.meta?.hideNavbar,
          'p-0': $route.meta?.fillScreen,
          'py-10 px-6 ': !$route.meta?.fillScreen,
        }"
      >
        <!-- <KeepAlive :max="20"> -->
        <component :is="Component" />
        <!-- </KeepAlive> -->
      </RouterView>
    </main>
    <Toaster />
  </div>
</template>
